// extracted by mini-css-extract-plugin
export default {"descriptionSection":"Profile_descriptionSection__3WnQB","subtitle":"Profile_subtitle__uNVBq","title":"Profile_title__IcxGK","userDataContainer":"Profile_userDataContainer__OmaEP"};